// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ArchiveSurveyMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ArchiveSurveyMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'archive'>
    )> }
  )> }
);

export type CreateQuestionMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.SurveyQuestionCreateInput;
  surveyId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CreateQuestionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id'>
      & { createQuestion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'SurveyQuestionModel' }
        & Pick<PrivateSchemaTypes.SurveyQuestionModel, 'id' | 'title' | 'type' | 'order'>
        & { content?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'SurveyQuestionContent' }
          & { options?: PrivateSchemaTypes.Maybe<Array<(
            { __typename?: 'SurveyQuestionOption' }
            & Pick<PrivateSchemaTypes.SurveyQuestionOption, 'label' | 'id'>
          )>> }
        )> }
      )> }
    )> }
  )> }
);

export type PublishMutationVariables = PrivateSchemaTypes.Exact<{
  surveyId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PublishMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'publish'>
    )> }
  )> }
);

export type UpdateSurveyMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.SurveyPatchInput;
}>;


export type UpdateSurveyMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'SurveyModelAsAdmin' }
        & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'title' | 'completed_at'>
      )> }
    )> }
  )> }
);

export type ResendMutationVariables = PrivateSchemaTypes.Exact<{
  surveyId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ResendMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'resend'>
    )> }
  )> }
);

export type ReorderQuestionsMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.ReorderItemsInput;
  surveyId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ReorderQuestionsMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id'>
      & { reorderQuestions?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'SurveyQuestionModel' }
        & Pick<PrivateSchemaTypes.SurveyQuestionModel, 'id' | 'title' | 'type' | 'order'>
        & { content?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'SurveyQuestionContent' }
          & { options?: PrivateSchemaTypes.Maybe<Array<(
            { __typename?: 'SurveyQuestionOption' }
            & Pick<PrivateSchemaTypes.SurveyQuestionOption, 'label' | 'id'>
          )>> }
        )> }
      )>> }
    )> }
  )> }
);


export const ArchiveSurveyDocument = gql`
    mutation archiveSurvey($id: PositiveInt!) {
  admin {
    survey(id: $id) {
      id
      archive
    }
  }
}
    `;
export type ArchiveSurveyMutationFn = Apollo.MutationFunction<ArchiveSurveyMutation, ArchiveSurveyMutationVariables>;

/**
 * __useArchiveSurveyMutation__
 *
 * To run a mutation, you first call `useArchiveSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSurveyMutation, { data, loading, error }] = useArchiveSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveSurveyMutation, ArchiveSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveSurveyMutation, ArchiveSurveyMutationVariables>(ArchiveSurveyDocument, options);
      }
export type ArchiveSurveyMutationHookResult = ReturnType<typeof useArchiveSurveyMutation>;
export type ArchiveSurveyMutationResult = Apollo.MutationResult<ArchiveSurveyMutation>;
export type ArchiveSurveyMutationOptions = Apollo.BaseMutationOptions<ArchiveSurveyMutation, ArchiveSurveyMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation createQuestion($input: SurveyQuestionCreateInput!, $surveyId: PositiveInt!) {
  admin {
    survey(id: $surveyId) {
      id
      createQuestion(input: $input) {
        id
        title
        type
        content {
          options {
            label
            id
          }
        }
        order
      }
    }
  }
}
    `;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const PublishDocument = gql`
    mutation publish($surveyId: PositiveInt!) {
  admin {
    survey(id: $surveyId) {
      id
      publish
    }
  }
}
    `;
export type PublishMutationFn = Apollo.MutationFunction<PublishMutation, PublishMutationVariables>;

/**
 * __usePublishMutation__
 *
 * To run a mutation, you first call `usePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMutation, { data, loading, error }] = usePublishMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function usePublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishMutation, PublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishMutation, PublishMutationVariables>(PublishDocument, options);
      }
export type PublishMutationHookResult = ReturnType<typeof usePublishMutation>;
export type PublishMutationResult = Apollo.MutationResult<PublishMutation>;
export type PublishMutationOptions = Apollo.BaseMutationOptions<PublishMutation, PublishMutationVariables>;
export const UpdateSurveyDocument = gql`
    mutation updateSurvey($id: PositiveInt!, $input: SurveyPatchInput!) {
  admin {
    survey(id: $id) {
      id
      patch(input: $input) {
        id
        title
        completed_at
      }
    }
  }
}
    `;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<UpdateSurveyMutation, UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>;
export const ResendDocument = gql`
    mutation resend($surveyId: PositiveInt!, $userId: PositiveInt!) {
  admin {
    survey(id: $surveyId) {
      id
      resend(userId: $userId)
    }
  }
}
    `;
export type ResendMutationFn = Apollo.MutationFunction<ResendMutation, ResendMutationVariables>;

/**
 * __useResendMutation__
 *
 * To run a mutation, you first call `useResendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMutation, { data, loading, error }] = useResendMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendMutation, ResendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendMutation, ResendMutationVariables>(ResendDocument, options);
      }
export type ResendMutationHookResult = ReturnType<typeof useResendMutation>;
export type ResendMutationResult = Apollo.MutationResult<ResendMutation>;
export type ResendMutationOptions = Apollo.BaseMutationOptions<ResendMutation, ResendMutationVariables>;
export const ReorderQuestionsDocument = gql`
    mutation reorderQuestions($input: ReorderItemsInput!, $surveyId: PositiveInt!) {
  admin {
    survey(id: $surveyId) {
      id
      reorderQuestions(input: $input) {
        id
        title
        type
        content {
          options {
            label
            id
          }
        }
        order
      }
    }
  }
}
    `;
export type ReorderQuestionsMutationFn = Apollo.MutationFunction<ReorderQuestionsMutation, ReorderQuestionsMutationVariables>;

/**
 * __useReorderQuestionsMutation__
 *
 * To run a mutation, you first call `useReorderQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderQuestionsMutation, { data, loading, error }] = useReorderQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useReorderQuestionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderQuestionsMutation, ReorderQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderQuestionsMutation, ReorderQuestionsMutationVariables>(ReorderQuestionsDocument, options);
      }
export type ReorderQuestionsMutationHookResult = ReturnType<typeof useReorderQuestionsMutation>;
export type ReorderQuestionsMutationResult = Apollo.MutationResult<ReorderQuestionsMutation>;
export type ReorderQuestionsMutationOptions = Apollo.BaseMutationOptions<ReorderQuestionsMutation, ReorderQuestionsMutationVariables>;